"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// source: https://msreference.cds-nonprod.collegeboard.org/palm/getDomainV1?cbDomain=country
var _default = [{
  countryName: 'Bonaire, Sint Eustasius, and Saba',
  dialCode: '599',
  iso: 'BQ'
}, {
  countryName: 'Curacao',
  dialCode: '599',
  iso: 'CW'
}, {
  countryName: 'Guernsey',
  dialCode: '44',
  iso: 'GG'
}, {
  countryName: 'Jersey',
  dialCode: '44',
  iso: 'JE'
}, {
  countryName: 'Saint Barthelemy',
  dialCode: '590',
  iso: 'BL'
}, {
  countryName: 'Saint Martin (French Part)',
  dialCode: '590',
  iso: 'MF'
}, {
  countryName: 'Sint Maarten (Dutch Part)',
  dialCode: '599',
  iso: 'SX'
}, {
  countryName: 'Isle Of Man',
  dialCode: '44',
  iso: 'IM'
}, {
  countryName: 'Andorra',
  dialCode: '376',
  iso: 'AD'
}, {
  countryName: 'United Arab Emirates',
  dialCode: '971',
  iso: 'AE'
}, {
  countryName: 'Afghanistan ',
  dialCode: '93',
  iso: 'AF'
}, {
  countryName: 'Antigua and Barbuda',
  dialCode: '1',
  iso: 'AG'
}, {
  countryName: 'Anguilla',
  dialCode: '1',
  iso: 'AI'
}, {
  countryName: 'Albania',
  dialCode: '355',
  iso: 'AL'
}, {
  countryName: 'Armenia',
  dialCode: '374',
  iso: 'AM'
}, {
  countryName: 'Angola',
  dialCode: '244',
  iso: 'AO'
}, {
  countryName: 'Antarctica',
  dialCode: '672',
  iso: 'AQ'
}, {
  countryName: 'Argentina',
  dialCode: '54',
  iso: 'AR'
}, {
  countryName: 'American Samoa',
  dialCode: '684',
  iso: 'AS'
}, {
  countryName: 'Austria',
  dialCode: '43',
  iso: 'AT'
}, {
  countryName: 'Australia',
  dialCode: '61',
  iso: 'AU'
}, {
  countryName: 'Aruba',
  dialCode: '297',
  iso: 'AW'
}, {
  countryName: 'Azerbaijan',
  dialCode: '994',
  iso: 'AZ'
}, {
  countryName: 'Bosnia and Herzegovina',
  dialCode: '387',
  iso: 'BA'
}, {
  countryName: 'Barbados',
  dialCode: '1',
  iso: 'BB'
}, {
  countryName: 'Bangladesh',
  dialCode: '880',
  iso: 'BD'
}, {
  countryName: 'Belgium',
  dialCode: '32',
  iso: 'BE'
}, {
  countryName: 'Burkina Faso',
  dialCode: '226',
  iso: 'BF'
}, {
  countryName: 'Bulgaria',
  dialCode: '359',
  iso: 'BG'
}, {
  countryName: 'Bahrain',
  dialCode: '973',
  iso: 'BH'
}, {
  countryName: 'Burundi',
  dialCode: '257',
  iso: 'BI'
}, {
  countryName: 'Benin',
  dialCode: '229',
  iso: 'BJ'
}, {
  countryName: 'Bermuda',
  dialCode: '1',
  iso: 'BM'
}, {
  countryName: 'Brunei Darussalam',
  dialCode: '673',
  iso: 'BN'
}, {
  countryName: 'Bolivia',
  dialCode: '591',
  iso: 'BO'
}, {
  countryName: 'Brazil',
  dialCode: '55',
  iso: 'BR'
}, {
  countryName: 'Bahamas',
  dialCode: '1',
  iso: 'BS'
}, {
  countryName: 'Bhutan',
  dialCode: '975',
  iso: 'BT'
}, {
  countryName: 'Bouvet Island',
  iso: 'BV'
}, {
  countryName: 'Botswana',
  dialCode: '267',
  iso: 'BW'
}, {
  countryName: 'Belarus',
  dialCode: '375',
  iso: 'BY'
}, {
  countryName: 'Belize',
  dialCode: '501',
  iso: 'BZ'
}, {
  countryName: 'Canada',
  dialCode: '1',
  iso: 'CA'
}, {
  countryName: 'Cocos (Keeling) Islands',
  dialCode: '61',
  iso: 'CC'
}, {
  countryName: 'Congo, The Democratic Republic Of The',
  dialCode: '243',
  iso: 'CD'
}, {
  countryName: 'Central African Republic',
  dialCode: '236',
  iso: 'CF'
}, {
  countryName: 'Congo',
  dialCode: '242',
  iso: 'CG'
}, {
  countryName: 'Switzerland',
  dialCode: '41',
  iso: 'CH'
}, {
  countryName: "Cote D'Ivoire",
  dialCode: '225',
  iso: 'CI'
}, {
  countryName: 'Cook Islands',
  dialCode: '682',
  iso: 'CK'
}, {
  countryName: 'Chile',
  dialCode: '56',
  iso: 'CL'
}, {
  countryName: 'Cameroon',
  dialCode: '237',
  iso: 'CM'
}, {
  countryName: 'China',
  dialCode: '86',
  iso: 'CN'
}, {
  countryName: 'Colombia',
  dialCode: '57',
  iso: 'CO'
}, {
  countryName: 'Costa Rica',
  dialCode: '506',
  iso: 'CR'
}, {
  countryName: 'Cuba',
  dialCode: '53',
  iso: 'CU'
}, {
  countryName: 'Cape Verde',
  dialCode: '238',
  iso: 'CV'
}, {
  countryName: 'Christmas Island',
  dialCode: '61',
  iso: 'CX'
}, {
  countryName: 'Cyprus',
  dialCode: '357',
  iso: 'CY'
}, {
  countryName: 'Czechia',
  dialCode: '420',
  iso: 'CZ'
}, {
  countryName: 'Germany',
  dialCode: '49',
  iso: 'DE'
}, {
  countryName: 'Djibouti',
  dialCode: '253',
  iso: 'DJ'
}, {
  countryName: 'Denmark',
  dialCode: '45',
  iso: 'DK'
}, {
  countryName: 'Dominica',
  dialCode: '1',
  iso: 'DM'
}, {
  countryName: 'Dominican Republic',
  dialCode: '1',
  iso: 'DO'
}, {
  countryName: 'Algeria',
  dialCode: '213',
  iso: 'DZ'
}, {
  countryName: 'Ecuador',
  dialCode: '593',
  iso: 'EC'
}, {
  countryName: 'Estonia',
  dialCode: '372',
  iso: 'EE'
}, {
  countryName: 'Egypt',
  dialCode: '20',
  iso: 'EG'
}, {
  countryName: 'Western Sahara',
  dialCode: '212',
  iso: 'EH'
}, {
  countryName: 'Eritrea',
  dialCode: '291',
  iso: 'ER'
}, {
  countryName: 'Spain',
  dialCode: '34',
  iso: 'ES'
}, {
  countryName: 'Ethiopia',
  dialCode: '251',
  iso: 'ET'
}, {
  countryName: 'Finland',
  dialCode: '358',
  iso: 'FI'
}, {
  countryName: 'Fiji',
  dialCode: '679',
  iso: 'FJ'
}, {
  countryName: 'Falkland Islands (Malvinas)',
  dialCode: '500',
  iso: 'FK'
}, {
  countryName: 'Micronesia, Federated States Of',
  dialCode: '691',
  iso: 'FM'
}, {
  countryName: 'Faroe Islands',
  dialCode: '298',
  iso: 'FO'
}, {
  countryName: 'France',
  dialCode: '33',
  iso: 'FR'
}, {
  countryName: 'Gabon ',
  dialCode: '241',
  iso: 'GA'
}, {
  countryName: 'United Kingdom',
  dialCode: '44',
  iso: 'GB'
}, {
  countryName: 'Grenada',
  dialCode: '1',
  iso: 'GD'
}, {
  countryName: 'Georgia',
  dialCode: '995',
  iso: 'GE'
}, {
  countryName: 'French Guiana',
  dialCode: '594',
  iso: 'GF'
}, {
  countryName: 'Ghana',
  dialCode: '233',
  iso: 'GH'
}, {
  countryName: 'Gibraltar',
  dialCode: '350',
  iso: 'GI'
}, {
  countryName: 'Greenland',
  dialCode: '299',
  iso: 'GL'
}, {
  countryName: 'Gambia',
  dialCode: '220',
  iso: 'GM'
}, {
  countryName: 'Guinea',
  dialCode: '224',
  iso: 'GN'
}, {
  countryName: 'Guadeloupe',
  dialCode: '590',
  iso: 'GP'
}, {
  countryName: 'Equatorial Guinea',
  dialCode: '240',
  iso: 'GQ'
}, {
  countryName: 'Greece',
  dialCode: '30',
  iso: 'GR'
}, {
  countryName: 'South Georgia and The South Sandwich Islands',
  iso: 'GS'
}, {
  countryName: 'Guatemala',
  dialCode: '502',
  iso: 'GT'
}, {
  countryName: 'Guam',
  dialCode: '1',
  iso: 'GU'
}, {
  countryName: 'Guinea-Bissau',
  dialCode: '245',
  iso: 'GW'
}, {
  countryName: 'Guyana',
  dialCode: '592',
  iso: 'GY'
}, {
  countryName: 'Hong Kong',
  dialCode: '852',
  iso: 'HK'
}, {
  countryName: 'Heard Island and Mcdonald Islands',
  iso: 'HM'
}, {
  countryName: 'Honduras',
  dialCode: '504',
  iso: 'HN'
}, {
  countryName: 'Croatia',
  dialCode: '385',
  iso: 'HR'
}, {
  countryName: 'Haiti',
  dialCode: '509',
  iso: 'HT'
}, {
  countryName: 'Hungary',
  dialCode: '36',
  iso: 'HU'
}, {
  countryName: 'Indonesia',
  dialCode: '62',
  iso: 'ID'
}, {
  countryName: 'Ireland',
  dialCode: '353',
  iso: 'IE'
}, {
  countryName: 'Israel',
  dialCode: '972',
  iso: 'IL'
}, {
  countryName: 'India',
  dialCode: '91',
  iso: 'IN'
}, {
  countryName: 'British Indian Ocean Territory',
  dialCode: '246',
  iso: 'IO'
}, {
  countryName: 'Iraq',
  dialCode: '964',
  iso: 'IQ'
}, {
  countryName: 'Iran, Islamic Republic Of',
  dialCode: '98',
  iso: 'IR'
}, {
  countryName: 'Iceland',
  dialCode: '354',
  iso: 'IS'
}, {
  countryName: 'Italy',
  dialCode: '39',
  iso: 'IT'
}, {
  countryName: 'Jamaica',
  dialCode: '1',
  iso: 'JM'
}, {
  countryName: 'Jordan',
  dialCode: '962',
  iso: 'JO'
}, {
  countryName: 'Japan',
  dialCode: '81',
  iso: 'JP'
}, {
  countryName: 'Kenya',
  dialCode: '254',
  iso: 'KE'
}, {
  countryName: 'Kyrgyzstan',
  dialCode: '996',
  iso: 'KG'
}, {
  countryName: 'Cambodia',
  dialCode: '855',
  iso: 'KH'
}, {
  countryName: 'Kiribati',
  dialCode: '686',
  iso: 'KI'
}, {
  countryName: 'Comoros',
  dialCode: '269',
  iso: 'KM'
}, {
  countryName: 'Saint Kitts and Nevis',
  dialCode: '1',
  iso: 'KN'
}, {
  countryName: 'Korea, North (DPR)',
  dialCode: '850',
  iso: 'KP'
}, {
  countryName: 'Korea, South (ROK)',
  dialCode: '82',
  iso: 'KR'
}, {
  countryName: 'Kuwait',
  dialCode: '965',
  iso: 'KW'
}, {
  countryName: 'Cayman Islands',
  dialCode: '1',
  iso: 'KY'
}, {
  countryName: 'Kazakhstan',
  dialCode: '7',
  iso: 'KZ'
}, {
  countryName: "Lao People's Democratic Republic ",
  dialCode: '856',
  iso: 'LA'
}, {
  countryName: 'Lebanon',
  dialCode: '961',
  iso: 'LB'
}, {
  countryName: 'Saint Lucia',
  dialCode: '1',
  iso: 'LC'
}, {
  countryName: 'Liechtenstein',
  dialCode: '423',
  iso: 'LI'
}, {
  countryName: 'Sri Lanka',
  dialCode: '94',
  iso: 'LK'
}, {
  countryName: 'Liberia',
  dialCode: '231',
  iso: 'LR'
}, {
  countryName: 'Lesotho',
  dialCode: '266',
  iso: 'LS'
}, {
  countryName: 'Lithuania',
  dialCode: '370',
  iso: 'LT'
}, {
  countryName: 'Luxembourg',
  dialCode: '352',
  iso: 'LU'
}, {
  countryName: 'Latvia',
  dialCode: '371',
  iso: 'LV'
}, {
  countryName: 'Libya',
  dialCode: '218',
  iso: 'LY'
}, {
  countryName: 'Morocco',
  dialCode: '212',
  iso: 'MA'
}, {
  countryName: 'Monaco',
  dialCode: '377',
  iso: 'MC'
}, {
  countryName: 'Moldova, Republic Of',
  dialCode: '373',
  iso: 'MD'
}, {
  countryName: 'Madagascar',
  dialCode: '261',
  iso: 'MG'
}, {
  countryName: 'Marshall Islands',
  dialCode: '692',
  iso: 'MH'
}, {
  countryName: 'North Macedonia',
  dialCode: '389',
  iso: 'MK'
}, {
  countryName: 'Mali',
  dialCode: '223',
  iso: 'ML'
}, {
  countryName: 'Myanmar',
  dialCode: '95',
  iso: 'MM'
}, {
  countryName: 'Mongolia',
  dialCode: '976',
  iso: 'MN'
}, {
  countryName: 'Macao',
  dialCode: '853',
  iso: 'MO'
}, {
  countryName: 'Northern Mariana Islands',
  dialCode: '1',
  iso: 'MP'
}, {
  countryName: 'Martinique',
  dialCode: '596',
  iso: 'MQ'
}, {
  countryName: 'Mauritania',
  dialCode: '222',
  iso: 'MR'
}, {
  countryName: 'Montserrat',
  dialCode: '1',
  iso: 'MS'
}, {
  countryName: 'Malta',
  dialCode: '356',
  iso: 'MT'
}, {
  countryName: 'Mauritius',
  dialCode: '230',
  iso: 'MU'
}, {
  countryName: 'Maldives',
  dialCode: '960',
  iso: 'MV'
}, {
  countryName: 'Malawi',
  dialCode: '265',
  iso: 'MW'
}, {
  countryName: 'Mexico',
  dialCode: '52',
  iso: 'MX'
}, {
  countryName: 'Malaysia',
  dialCode: '60',
  iso: 'MY'
}, {
  countryName: 'Mozambique',
  dialCode: '258',
  iso: 'MZ'
}, {
  countryName: 'Namibia',
  dialCode: '264',
  iso: 'NA'
}, {
  countryName: 'New Caledonia',
  dialCode: '687',
  iso: 'NC'
}, {
  countryName: 'Niger',
  dialCode: '227',
  iso: 'NE'
}, {
  countryName: 'Norfolk Island',
  dialCode: '672',
  iso: 'NF'
}, {
  countryName: 'Nigeria',
  dialCode: '234',
  iso: 'NG'
}, {
  countryName: 'Nicaragua',
  dialCode: '505',
  iso: 'NI'
}, {
  countryName: 'Netherlands',
  dialCode: '31',
  iso: 'NL'
}, {
  countryName: 'Norway',
  dialCode: '47',
  iso: 'NO'
}, {
  countryName: 'Nepal',
  dialCode: '977',
  iso: 'NP'
}, {
  countryName: 'Nauru',
  dialCode: '674',
  iso: 'NR'
}, {
  countryName: 'Niue',
  dialCode: '683',
  iso: 'NU'
}, {
  countryName: 'New Zealand',
  dialCode: '64',
  iso: 'NZ'
}, {
  countryName: 'Oman',
  dialCode: '968',
  iso: 'OM'
}, {
  countryName: 'Panama',
  dialCode: '507',
  iso: 'PA'
}, {
  countryName: 'Peru',
  dialCode: '51',
  iso: 'PE'
}, {
  countryName: 'French Polynesia',
  dialCode: '689',
  iso: 'PF'
}, {
  countryName: 'Papua New Guinea',
  dialCode: '675',
  iso: 'PG'
}, {
  countryName: 'Philippines',
  dialCode: '63',
  iso: 'PH'
}, {
  countryName: 'Pakistan',
  dialCode: '92',
  iso: 'PK'
}, {
  countryName: 'Poland',
  dialCode: '48',
  iso: 'PL'
}, {
  countryName: 'Saint Pierre and Miquelon',
  dialCode: '508',
  iso: 'PM'
}, {
  countryName: 'Pitcairn',
  dialCode: '872',
  iso: 'PN'
}, {
  countryName: 'Puerto Rico',
  dialCode: '1',
  iso: 'PR'
}, {
  countryName: 'Palestine, State of',
  dialCode: '970',
  iso: 'PS'
}, {
  countryName: 'Portugal',
  dialCode: '351',
  iso: 'PT'
}, {
  countryName: 'Palau',
  dialCode: '680',
  iso: 'PW'
}, {
  countryName: 'Paraguay',
  dialCode: '595',
  iso: 'PY'
}, {
  countryName: 'Qatar',
  dialCode: '974',
  iso: 'QA'
}, {
  countryName: 'Reunion',
  dialCode: '262',
  iso: 'RE'
}, {
  countryName: 'Romania',
  dialCode: '40',
  iso: 'RO'
}, {
  countryName: 'Russian Federation',
  dialCode: '7',
  iso: 'RU'
}, {
  countryName: 'Rwanda',
  dialCode: '250',
  iso: 'RW'
}, {
  countryName: 'Saudi Arabia',
  dialCode: '966',
  iso: 'SA'
}, {
  countryName: 'Solomon Islands',
  dialCode: '677',
  iso: 'SB'
}, {
  countryName: 'Seychelles',
  dialCode: '248',
  iso: 'SC'
}, {
  countryName: 'Sudan',
  dialCode: '249',
  iso: 'SD'
}, {
  countryName: 'Sweden',
  dialCode: '46',
  iso: 'SE'
}, {
  countryName: 'Singapore',
  dialCode: '65',
  iso: 'SG'
}, {
  countryName: 'Saint Helena, Ascension and Tristan da Cunha',
  dialCode: '290',
  iso: 'SH'
}, {
  countryName: 'Slovenia',
  dialCode: '386',
  iso: 'SI'
}, {
  countryName: 'Svalbard and Jan Mayen',
  dialCode: '47',
  iso: 'SJ'
}, {
  countryName: 'Slovakia',
  dialCode: '421',
  iso: 'SK'
}, {
  countryName: 'Sierra Leone',
  dialCode: '232',
  iso: 'SL'
}, {
  countryName: 'San Marino',
  dialCode: '378',
  iso: 'SM'
}, {
  countryName: 'Senegal',
  dialCode: '221',
  iso: 'SN'
}, {
  countryName: 'Somalia',
  dialCode: '252',
  iso: 'SO'
}, {
  countryName: 'Suriname',
  dialCode: '597',
  iso: 'SR'
}, {
  countryName: 'Sao Tome and Principe',
  dialCode: '239',
  iso: 'ST'
}, {
  countryName: 'El Salvador',
  dialCode: '503',
  iso: 'SV'
}, {
  countryName: 'Syrian Arab Republic',
  dialCode: '963',
  iso: 'SY'
}, {
  countryName: 'Eswatini',
  dialCode: '268',
  iso: 'SZ'
}, {
  countryName: 'Turks and Caicos Islands',
  dialCode: '1',
  iso: 'TC'
}, {
  countryName: 'Chad',
  dialCode: '235',
  iso: 'TD'
}, {
  countryName: 'French Southern Territories',
  iso: 'TF'
}, {
  countryName: 'Togo',
  dialCode: '228',
  iso: 'TG'
}, {
  countryName: 'Thailand',
  dialCode: '66',
  iso: 'TH'
}, {
  countryName: 'Tajikistan',
  dialCode: '992',
  iso: 'TJ'
}, {
  countryName: 'Tokelau',
  dialCode: '690',
  iso: 'TK'
}, {
  countryName: 'Timor-Leste',
  dialCode: '670',
  iso: 'TL'
}, {
  countryName: 'Turkmenistan',
  dialCode: '993',
  iso: 'TM'
}, {
  countryName: 'Tunisia',
  dialCode: '216',
  iso: 'TN'
}, {
  countryName: 'Tonga',
  dialCode: '676',
  iso: 'TO'
}, {
  countryName: 'Turkey',
  dialCode: '90',
  iso: 'TR'
}, {
  countryName: 'Trinidad and Tobago',
  dialCode: '1',
  iso: 'TT'
}, {
  countryName: 'Tuvalu',
  dialCode: '688',
  iso: 'TV'
}, {
  countryName: 'Taiwan',
  dialCode: '886',
  iso: 'TW'
}, {
  countryName: 'Tanzania, United Republic Of',
  dialCode: '255',
  iso: 'TZ'
}, {
  countryName: 'Ukraine',
  dialCode: '380',
  iso: 'UA'
}, {
  countryName: 'Uganda',
  dialCode: '256',
  iso: 'UG'
}, {
  countryName: 'United States Minor Outlying Islands',
  iso: 'UM'
}, {
  countryName: 'United States',
  dialCode: '1',
  iso: 'US'
}, {
  countryName: 'Uruguay',
  dialCode: '598',
  iso: 'UY'
}, {
  countryName: 'Uzbekistan',
  dialCode: '998',
  iso: 'UZ'
}, {
  countryName: 'Holy See (Vatican City State)',
  dialCode: '39',
  iso: 'VA'
}, {
  countryName: 'Saint Vincent and The Grenadines',
  dialCode: '1',
  iso: 'VC'
}, {
  countryName: 'Venezuela',
  dialCode: '58',
  iso: 'VE'
}, {
  countryName: 'Virgin Islands, British',
  dialCode: '1',
  iso: 'VG'
}, {
  countryName: 'Virgin Islands, U.S.',
  dialCode: '1',
  iso: 'VI'
}, {
  countryName: 'Viet Nam',
  dialCode: '84',
  iso: 'VN'
}, {
  countryName: 'Vanuatu',
  dialCode: '678',
  iso: 'VU'
}, {
  countryName: 'Wallis and Futuna',
  dialCode: '681',
  iso: 'WF'
}, {
  countryName: 'Samoa',
  dialCode: '685',
  iso: 'WS'
}, {
  countryName: 'Yemen',
  dialCode: '967',
  iso: 'YE'
}, {
  countryName: 'Mayotte',
  dialCode: '269',
  iso: 'YT'
}, {
  countryName: 'South Africa',
  dialCode: '27',
  iso: 'ZA'
}, {
  countryName: 'Zambia',
  dialCode: '260',
  iso: 'ZM'
}, {
  countryName: 'Zimbabwe',
  dialCode: '263',
  iso: 'ZW'
}, {
  countryName: 'Aaland Islands',
  dialCode: '358',
  iso: 'AX'
}, {
  countryName: 'Serbia',
  dialCode: '381',
  iso: 'RS'
}, {
  countryName: 'Montenegro',
  dialCode: '382',
  iso: 'ME'
}, {
  countryName: 'South Sudan',
  dialCode: '211',
  iso: 'SS'
}, {
  countryName: 'Kosovo',
  dialCode: '381',
  iso: 'XK'
}];
exports.default = _default;